import { JSX } from 'react';

import { Button, Label, TTranslator } from '@smartshell/ui-kit';
import cn from 'classnames';

import { TLocalesKeys } from 'localization';
import { EAdvertisementStatus, IMyAdvertisement } from 'types';

import { IModalAdvertisementManagerState } from '../../../../interfaces';
import s from './MyAdvertisementItem.module.scss';

export const getAdvertisementLabel = (
  t: TTranslator<TLocalesKeys>,
  status?: EAdvertisementStatus,
  mobile?: boolean
): JSX.Element => {
  switch (status) {
    case EAdvertisementStatus.ACTIVE:
      return (
        <Label
          text={t('advertisement.status.label.active')}
          iconName="OpenedEyeIcon"
          color="green"
          className={s.status_label_active}
        />
      );
    case EAdvertisementStatus.MODERATION:
      return (
        <Label
          text={t('moderation')}
          iconName="ClockIcon"
          color="orange"
          className={s.status_label}
        />
      );
    case EAdvertisementStatus.COMPLETED:
      return (
        <Label
          text={t('completed')}
          iconName="CheckIcon"
          color="gray-secondary"
          className={s.status_label}
        />
      );
    case EAdvertisementStatus.REJECTED:
      return (
        <Label
          text={t('rejected')}
          iconName={mobile ? 'CommentIcon' : 'CircleCloseIcon'}
          color="red"
          iconPosition={mobile ? 'right' : 'left'}
          className={cn(s.status_label, mobile && s.status_label_rejected)}
        />
      );
    case EAdvertisementStatus.EXPIRED:
      return (
        <Label
          text={t('completed')}
          iconName="CheckIcon"
          color="gray-secondary"
          className={s.status_label}
        />
      );
    default:
      return <span>статус не определен</span>;
  }
};

export const getActionButton = (
  t: TTranslator<TLocalesKeys>,
  setAdvertisementManagerState: React.Dispatch<
    React.SetStateAction<IModalAdvertisementManagerState | null>
  >,
  setOpenUnpublishedModal: React.Dispatch<React.SetStateAction<boolean>>,
  handledRepublishAdvertisement: (id: string) => Promise<any>,
  data?: IMyAdvertisement,
  loading?: boolean,
  disabled?: boolean
): JSX.Element => {
  switch (data?.status) {
    case EAdvertisementStatus.ACTIVE:
      return (
        <Button
          className={cn(s.button, s.unpublished)}
          variant="secondary"
          iconName="EyeNoIcon"
          onClick={(e) => {
            e.stopPropagation();

            setOpenUnpublishedModal(true);
          }}
          disabled={disabled}
          isLoading={loading}
        >
          {t('advertisement.info.button.unpublished')}
        </Button>
      );
    case EAdvertisementStatus.MODERATION:
      return (
        <Button
          className={s.button}
          variant="secondary"
          iconName="EditIcon"
          onClick={(e) => {
            e.stopPropagation();

            setAdvertisementManagerState({
              mode: 'edit',
              advertisement: data,
            });
          }}
          disabled={disabled}
        >
          {t('edit')}
        </Button>
      );
    case EAdvertisementStatus.REJECTED:
      return (
        <Button
          className={s.button}
          variant="secondary"
          iconName="EditIcon"
          onClick={(e) => {
            e.stopPropagation();

            setAdvertisementManagerState({
              mode: 'edit',
              advertisement: data,
            });
          }}
          disabled={disabled}
        >
          {t('edit')}
        </Button>
      );
    case EAdvertisementStatus.COMPLETED:
    case EAdvertisementStatus.EXPIRED:
      return (
        <Button
          className={cn(s.button, s.republished)}
          variant="secondary"
          iconName="OpenedEyeIcon"
          onClick={(e) => {
            e.stopPropagation();
            handledRepublishAdvertisement(data?.id);
          }}
          isLoading={loading}
          disabled={disabled}
        >
          {t('advertisement.info.button.published')}
        </Button>
      );

    default:
      return (
        <Button
          className={s.button}
          variant="secondary"
          disabled={disabled}
          iconName="EditIcon"
        >
          {t('edit')}
        </Button>
      );
  }
};

export const getDropdownTextAction = (
  t: TTranslator<TLocalesKeys>,
  status?: EAdvertisementStatus
): string => {
  switch (status) {
    case EAdvertisementStatus.ACTIVE:
      return t('advertisement.info.button.unpublished');

    case EAdvertisementStatus.COMPLETED:
    case EAdvertisementStatus.REJECTED:
    case EAdvertisementStatus.EXPIRED:
      return t('advertisement.info.button.published');

    default:
      return t('edit');
  }
};
